import { useCallback, useState } from 'react'

export type SectionKey = 'discount' | 'shippingDiscount'

interface UseToggleSectionsReturn {
  isOpen: (key: SectionKey) => boolean
  toggle: (key: SectionKey) => void
}

export const useToggleSections = (
  defaultOpen: SectionKey[] = [],
): UseToggleSectionsReturn => {
  const [openSections, setOpenSections] = useState<Set<SectionKey>>(
    new Set(defaultOpen),
  )

  const isOpen = useCallback(
    (key: SectionKey) => openSections.has(key),
    [openSections],
  )

  const toggle = useCallback((key: SectionKey) => {
    setOpenSections((prev) => {
      const next = new Set(prev)
      if (next.has(key)) {
        next.delete(key)
      }
      else {
        next.add(key)
      }
      return next
    })
  }, [])

  return { isOpen, toggle }
}
